import styled from 'styled-components';

export const PurchaseAmount = styled.div`
  display: flex;
  justify-content: flex-end;
  font-weight: bold;
`;

export const Rewards = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: ${Styles.fontWeight.heavy};
`;

export const Reward = styled.span`
  color: ${Styles.color.primary};
  font-weight: ${Styles.fontWeight.heavy};
  display: flex;
  flex-direction: column;
  align-items: center;
`;
